import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Button, Container, Row, Col, Form, FormLabel, Alert, Tabs, Tab } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { Link, NavLink } from 'react-router-dom';
import Select from 'react-select';
import axios from 'axios';

import CartCtx from '../CartCtx';
import CheckoutCompleteModal from './CheckoutCompleteModal';
import BlackListModal from './BlackListModal';
import CartItem from '../cart/CartItem';
import { isIterableArray } from '../block-slider/utils';
import AlertCart from '../cart/AlertCart';

import "../../scss/components/pages/checkout/checkout.scss";

export const CHECKOUT_STORAGE_KEY = 'checkout_form_data';

const getSavedFormData = () => {
    try {
        const raw = sessionStorage.getItem(CHECKOUT_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const saveFormData = (data) => {
    try {
        sessionStorage.setItem(CHECKOUT_STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
        console.warn('Не удалось сохранить данные формы', e);
    }
};

const clearFormData = () => {
    try {
        sessionStorage.removeItem(CHECKOUT_STORAGE_KEY);
    } catch { }
};

const Checkout = (props) => {
    const context = useContext(CartCtx);

    // ===================== STATE =====================
    const [orderNumber, setOrderNumber] = useState(0);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [phones, setPhones] = useState([]);
    const [delivery, setDelivery] = useState('1');
    const [pickupTcId, setPickupTcId] = useState(''); // ТЦ для самовывоза
    const [payment, setPayment] = useState('1');
    const [commentUser, setCommentUser] = useState('');
    const [city, setCity] = useState('');
    const [address, setAddress] = useState('');
    const [home, setHome] = useState('');
    const [flat, setFlat] = useState('');
    // const [idCenter, setIdCenter] = useState(''); // ближайший ТЦ при доставке
    const [companyName, setCompanyName] = useState('');
    const [companyInn, setCompanyInn] = useState('');
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        city: '',
        address: '',
        home: ''
    });
    const [valid, setValid] = useState(false);
    const [submitTry, setSubmitTry] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const [checkPhone, setCheckPhone] = useState(true);
    const [userData, setUserData] = useState(null);
    const [cities, setCities] = useState([]);
    const [texts, setTexts] = useState({});
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [tcList, setTcList] = useState([]);

    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)

    // ===================== HANDLERS =====================
    const changeInput = useCallback((e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'firstName': setFirstName(value); break;
            case 'lastName': setLastName(value); break;
            case 'email': setEmail(value); break;
            case 'phone': setPhone(value); break;
            case 'payment': setPayment(value); break;
            case 'comment_user': setCommentUser(value); break;
            case 'city': setCity(value); break;
            case 'address': setAddress(value); break;
            case 'home': setHome(value); break;
            case 'flat': setFlat(value); break;
            case 'companyName': setCompanyName(value); break;
            case 'companyInn': setCompanyInn(value); break;
            default: break;
        }
    }, []);

    const selectPhone = useCallback((e) => {
        setPhone(e.target.value);
    }, []);

    const selectPickupTc = useCallback((e) => {
        setPickupTcId(e.target.value);
    }, []);

    // const selectCenter = useCallback((e) => {
    //     setIdCenter(e.target.value);
    // }, []);

    const ppConfirm = useCallback((e) => {
        setConfirmed(e.target.checked);
    }, []);

    const toggleRadioState = useCallback((e) => {
        setDelivery(e.target.value);
    }, []);

    // ===================== DATA FETCHING =====================
    const getProducts = useCallback(() => {
        setIsLoading(true);
        const ids = context.cart.map(i => i.id);

        axios.post(`${process.env.REACT_APP_API_BASE}/products/products-for-cart`, { ids })
            .then(response => {
                if (isIterableArray(response.data.data)) {
                    const res = response.data.data.map(prod => ({
                        ...prod,
                        count_cart: context.cart.find(i => i.id == prod.id)?.count_cart
                    }));
                    setProducts(res);
                }
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [context.cart]);

    // ===================== EFFECTS =====================
    // Первичная загрузка
    useEffect(() => {
        if (!localStorage.getItem('galaxy-token')) window.location.replace('/')
        const saved = getSavedFormData();
        console.log(saved)
        if (saved) {
            if (saved.firstName) setFirstName(saved.firstName);
            if (saved.lastName) setLastName(saved.lastName);
            if (saved.email) setEmail(saved.email);
            if (saved.phone) setPhone(saved.phone);
            if (saved.delivery) setDelivery(saved.delivery);
            if (saved.pickupTcId) {
                setPickupTcId(saved.pickupTcId)
            }
            else {
                setPickupTcId(null)
            }
            if (saved.payment) setPayment(saved.payment);
            if (saved.commentUser) setCommentUser(saved.commentUser);
            if (saved.city) setCity(saved.city);
            if (saved.address) setAddress(saved.address);
            if (saved.home) setHome(saved.home);
            if (saved.flat) setFlat(saved.flat);
            // if (saved.idCenter) setIdCenter(saved.idCenter);
            if (saved.companyName) setCompanyName(saved.companyName);
            if (saved.companyInn) setCompanyInn(saved.companyInn);
            // confirmed намеренно не восстанавливаем
            // if (typeof saved.confirmed === 'boolean') setConfirmed(saved.confirmed);
        }

        getProducts();

        axios.get(`${process.env.REACT_APP_API_BASE}/pages/cart-text`)
            .then(response => setTexts(response.data))
            .catch(err => console.error(err));

        axios.get(`${process.env.REACT_APP_API_BASE}/pages/get-cities`)
            .then(response => setCities(response.data.data))
            .catch(err => console.error(err));

        // Автозаполнение из профиля
        if (localStorage.getItem('galaxy-token')) {
            axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/profile`, {
                jwt: localStorage.getItem('galaxy-token')
            })
                .then(response => {
                    const info = response.data.data.info;
                    setUserData(info);

                    if (info.name) setFirstName(info.name);
                    if (info.email) setEmail(info.email);
                    if (info.surname) setLastName(info.surname);
                    if (info.phones?.length > 0) setPhone(info.phones[0]);
                    if (info.city) setCity(info.city);
                    if (info.street) setAddress(info.street);
                    if (info.home) setHome(info.home);
                    if (info.flat) setFlat(info.flat);
                    if (info.company_inn) setCompanyInn(info.company_inn);
                    if (info.company_name) setCompanyName(info.company_name);
                    if (info.phones?.length > 1) setPhones(info.phones);
                })
                .catch(err => console.error(err));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Автосохранение в sessionStorage
    useEffect(() => {
        if (isLoading) return;

        const dataToSave = {
            firstName,
            lastName,
            email,
            phone,
            delivery,
            pickupTcId,
            payment,
            commentUser,
            city,
            address,
            home,
            flat,
            // idCenter,
            companyName,
            companyInn,
            // confirmed не сохраняем / не восстанавливаем
        };

        saveFormData(dataToSave);
    }, [
        firstName,
        lastName,
        email,
        phone,
        delivery,
        pickupTcId,
        payment,
        commentUser,
        city,
        address,
        home,
        flat,
        // idCenter,
        companyName,
        companyInn,
        isLoading,
    ]);

    // Построение списка ТЦ
    useEffect(() => {
        if (isIterableArray(context?.tcData?.list) && !isIterableArray(tcList)) {
            const list = context.tcData.list.reduce((acc, item) => {
                item.ts_list.forEach(tc => {
                    acc.push({
                        tcId: tc.id,
                        tcName: tc.address
                    });
                });
                return acc;
            }, []);

            if (!pickupTcId) {
                const firstSelectedTc = list[0]
                setPickupTcId(firstSelectedTc.tcId)
            }
            // setIdCenter(firstSelectedTc.tcId)

            setTcList(list);
        }
    }, [context?.tcData?.list, tcList, pickupTcId]);

    // ===================== SUBMIT =====================
    const submitOrder = useCallback(() => {
        setIsLoadingSubmit(true)
        const newErrors = { ...errors };

        newErrors.firstName =
            firstName.length < 2
                ? 'Поле "Имя" обязательно для заполнения'
                : '';

        newErrors.lastName =
            lastName.length < 2
                ? 'Поле "Фамилия" обязательно для заполнения'
                : '';

        const phoneDigits = phone.replace(/\D/g, '')

        newErrors.phone =
            phoneDigits.length === 0
                ? 'Поле "Телефон" обязательно для заполнения'
                : phoneDigits.length !== 11
                    ? 'Поле "Телефон" заполнено неверно'
                    : '';

        if (delivery == 99) {
            newErrors.id_center = ''

            newErrors.city =
                city.length < 2
                    ? 'Поле "Город" обязательно для заполнения'
                    : '';
            newErrors.address =
                address.length < 2
                    ? 'Поле "Адрес" обязательно для заполнения'
                    : '';
            newErrors.home =
                home.length < 1
                    ? 'Поле "Дом" обязательно для заполнения'
                    : '';
        }
        else {
            newErrors.city = ''
            newErrors.address = ''
            newErrors.home = ''

            newErrors.id_center =
                !!!pickupTcId
                    ? 'Выберите ТЦ для самовывоза'
                    : '';

        }

        let errorCount = 0;
        for (let err in newErrors) {
            if (newErrors.hasOwnProperty(err) && newErrors[err].length > 0) {
                errorCount++;
            }
        }

        setErrors(newErrors);
        setSubmitTry(true);

        if (errorCount === 0) {
            const orderInfo = products.map(item => {
                const itemPriceData = item?.tc?.find(t => t.id == context.selectedCenter?.id)?.priceBadgeStock?.price;
                const itemPrice = itemPriceData?.discountPrice ? itemPriceData?.discountPrice : itemPriceData?.price;
                return {
                    product_id: item.id,
                    count: item.count_cart,
                    price: Math.round((itemPrice * (item.step || 1)) * 100) / 100
                };
            });


            const postData = {
                order_numb: Math.floor(Date.now() / 1000),
                name: `${firstName} ${lastName}`,
                city: delivery === '99' ? city : '',
                address: delivery === '99' ? address : '',
                home: delivery === '99' ? home : '',
                flat: delivery === '99' ? flat : '',
                phone,
                email,
                order_info: orderInfo,
                order_summ: context.getTotalSumm(products),
                delivery,
                payment,
                id_center: delivery === '1' ? pickupTcId : null,
                comment_user: commentUser,
                company_inn: companyInn,
                company_name: companyName,
                checkPhone: true,
            };


            let postURL = `${process.env.REACT_APP_API_BASE}/addorder`;
            let postConfig = {};

            if (localStorage.getItem('galaxy-token')) {
                postURL += `?jwt=${localStorage.getItem('galaxy-token')}`;
                postConfig = {
                    headers: { Authorization: "Bearer " + localStorage.getItem('galaxy-token') }
                };
            }


            axios.post(postURL, postData, postConfig)
                .then(response => {
                    if (response.status === 200) {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        clearFormData();

                        setTimeout(() => {
                            setValid(true);
                            setOrderNumber(postData.order_numb);
                        }, 400);
                    }
                })
                .catch(err => {
                    console.error(err);
                    if (err.msg === 'User in ban list') {
                        setCheckPhone(false);
                    }
                })
                .finally(() => {
                    setIsLoadingSubmit(false)
                });
        }
    }, [
        firstName, lastName, phone, email, delivery, city, address, home, flat,
        payment,
        // idCenter, 
        pickupTcId, commentUser, companyInn, companyName,
        products, context, errors
    ]);

    // ===================== RENDER =====================
    if (isLoading) {
        return (
            <main className='page-checkout'>
                <Container>
                    <h3>Оформление заказа</h3>
                    <p>Загрузка...</p>
                </Container>
            </main>
        );
    }

    if (context.cart.length === 0) {
        return (
            <main className='page-checkout'>
                <Container>
                    <div className="cart-empty">
                        <h3>Корзина пуста</h3>
                        <Link to="/" className="btn btn-primary">Вернуться на главную</Link>
                    </div>
                </Container>
            </main>
        );
    }

    const totalSumm = context.getTotalSumm(products);

    return (
        <main className='page-checkout'>
            <Container>
                <h3>Оформление заказа</h3>
                <Row>
                    <Col xs={12} lg={8}>
                        {totalSumm < texts?.min_price && (
                            <Alert variant="danger">
                                <Alert.Heading>Внимание!</Alert.Heading>
                                <p>Сумма минимального заказа {texts?.min_price} рублей.</p>
                            </Alert>
                        )}

                        <div className="checkout-form">
                            {/* ========== ШАГ 1: Контакты ========== */}
                            <div className="checkout-form__step">
                                <div className="checkout-form__step__number">
                                    <span>1</span>
                                </div>
                                <div className="checkout-form__step__wrap">
                                    <h5>Контактные данные</h5>

                                    {userData && (
                                        <div className="checkout-login">
                                            <Form.Group controlId="logFName" className="half-width">
                                                <Form.Label>Имя</Form.Label>
                                                <Form.Control
                                                    readOnly={!!userData.name}
                                                    type="text"
                                                    name="firstName"
                                                    value={firstName}
                                                    onChange={changeInput}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="logLName" className="half-width">
                                                <Form.Label className='pl-sm-3 pr-4'>Фамилия</Form.Label>
                                                <Form.Control
                                                    readOnly={!!userData.surname}
                                                    type="text"
                                                    name="lastName"
                                                    value={lastName}
                                                    onChange={changeInput}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="logPhone" className='w-100'>
                                                <Form.Label>Телефон</Form.Label>
                                                <InputMask
                                                    readOnly={!!isIterableArray(userData.phones)}
                                                    mask="+7(999)-999-9999"
                                                    name="phone"
                                                    value={phone}
                                                    onChange={changeInput}
                                                    className="form-control"
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="logEmail" className='w-100'>
                                                <Form.Label className="logEmail">E-mail</Form.Label>
                                                <Form.Control
                                                    readOnly={!!userData.email}
                                                    type="email"
                                                    name="email"
                                                    value={email}
                                                    onChange={changeInput}
                                                />
                                            </Form.Group>
                                            <Form.Group>&nbsp;</Form.Group>

                                            {phones.length > 1 && (
                                                <Form.Group>
                                                    <Form.Control
                                                        as="select"
                                                        onChange={selectPhone}
                                                        value={phone}
                                                        style={{ width: '75%', marginLeft: '27%' }}
                                                    >
                                                        {phones.map((p, index) => (
                                                            <option value={p} key={index}>{p}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            )}
                                        </div>
                                    )
                                    }
                                    {/* (
                                        <Tabs defaultActiveKey="contact01" transition={false} id="contactTabs">
                                            <Tab eventKey="contact01" title="Я новый покупатель">
                                                <div className="checkout-login">
                                                    <Form.Group controlId="logFName" className="half-width">
                                                        <Form.Label>Имя</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="firstName"
                                                            value={firstName}
                                                            onChange={changeInput}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="logLName" className="half-width">
                                                        <Form.Label className='pl-sm-3 pr-4'>Фамилия</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="lastName"
                                                            value={lastName}
                                                            onChange={changeInput}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="logPhone" className='w-100'>
                                                        <Form.Label>Телефон</Form.Label>
                                                        <InputMask
                                                            mask="+7(999)-999-9999"
                                                            name="phone"
                                                            value={phone}
                                                            onChange={changeInput}
                                                            className="form-control"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="logEmail" className='w-100'>
                                                        <Form.Label className="logEmail">E-mail</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            name="email"
                                                            value={email}
                                                            onChange={changeInput}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group>&nbsp;</Form.Group>

                                                    {phones.length > 1 && (
                                                        <Form.Group>
                                                            <Form.Control
                                                                as="select"
                                                                onChange={selectPhone}
                                                                value={phone}
                                                                style={{ width: '75%', marginLeft: '27%' }}
                                                            >
                                                                {phones.map((p, index) => (
                                                                    <option value={p} key={index}>{p}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    )}
                                                </div>
                                            </Tab>

                                            <Tab eventKey="contact02" title="Я постоянный клиент">
                                                <div className="checkout-login">
                                                    <CartCtx.Consumer>
                                                        {({ setIsShowAuthModal }) => (
                                                            <Button
                                                                onClick={() => setIsShowAuthModal(true)}
                                                                className='w-100 mb-3'
                                                                variant="primary"
                                                            >
                                                                Войти в профиль
                                                            </Button>
                                                        )}
                                                    </CartCtx.Consumer>
                                                </div>
                                            </Tab>
                                        </Tabs>
                                    )} */}

                                    {texts?.text2?.text && <AlertCart data={texts.text2} />}
                                </div>
                            </div>

                            {/* ========== ШАГ 2: Доставка ========== */}
                            <div className="checkout-form__step">
                                <div className="checkout-form__step__number">
                                    <span>2</span>
                                </div>
                                <div className="checkout-form__step__wrap">
                                    <h5>Доставка</h5>
                                    <div className="checkout-delivery">
                                        {/* Самовывоз */}
                                        <Form.Group
                                            className={`checkout-delivery__item${delivery === '1' ? ' open' : ''}`}
                                        >
                                            <Form.Check
                                                type="radio"
                                                id="delivery1"
                                                name="delivery"
                                                label='Самовывоз из магазина'
                                                onChange={toggleRadioState}
                                                value="1"
                                                checked={delivery === '1'}
                                            />
                                            <div className="checkout-delivery__dropdown">
                                                <div className="checkout-delivery__dropdown__wrap">
                                                    <div className="row-city">
                                                        <Form.Group>
                                                            <Form.Control
                                                                as="select"
                                                                onChange={selectPickupTc}
                                                                value={pickupTcId}
                                                            >
                                                                {isIterableArray(tcList) &&
                                                                    tcList.map(tc => (
                                                                        <option key={tc.tcId} value={tc.tcId}>
                                                                            {tc.tcName}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </Form.Control>
                                                        </Form.Group>
                                                        <div className="select_info" />
                                                    </div>
                                                </div>
                                            </div>
                                        </Form.Group>

                                        {/* Доставка курьером */}
                                        <Form.Group
                                            className={`checkout-delivery__item${delivery === '99' ? ' open' : ''}`}
                                        >
                                            <Form.Check
                                                type="radio"
                                                id="delivery2"
                                                name="delivery"
                                                label='Доставка'
                                                onChange={toggleRadioState}
                                                value="99"
                                                checked={delivery === '99'}
                                            />
                                            <div className="checkout-delivery__dropdown">
                                                <div className="checkout-delivery__dropdown__wrap">
                                                    <p className="subtitle">
                                                        Расчет стоимости доставки проводится дополнительно и будет сообщен оператором
                                                    </p>
                                                    <FormLabel className="req">Укажите адрес доставки</FormLabel>
                                                    <Form.Group className="row-address">
                                                        {/* {cities?.length > 0 && (
                                                            <Select
                                                                placeholder={'Населённый пункт'}
                                                                options={cities.map(c => ({ value: c, label: c }))}
                                                                onChange={(e) => setCity(e.value)}
                                                                value={cities
                                                                    .map(c => ({ value: c, label: c }))
                                                                    .find(item => item.value === city)
                                                                }
                                                            />
                                                        )} */}
                                                        <Form.Control
                                                            type="text"
                                                            name="city"
                                                            value={city}
                                                            onChange={changeInput}
                                                            placeholder="Населённый пункт"
                                                            className="address_str"
                                                        />
                                                        <Form.Control
                                                            type="text"
                                                            name="address"
                                                            value={address}
                                                            onChange={changeInput}
                                                            placeholder="Микрорайон / улица / проспект / бульвар *"
                                                            className="address_str"
                                                        />
                                                        <Form.Control
                                                            type="text"
                                                            name="home"
                                                            value={home}
                                                            onChange={changeInput}
                                                            placeholder="Дом № *"
                                                            className="address_dom"
                                                        />
                                                        <Form.Control
                                                            type="text"
                                                            name="flat"
                                                            value={flat}
                                                            onChange={changeInput}
                                                            placeholder="Кв. №"
                                                            className="address_kv"
                                                        />
                                                    </Form.Group>

                                                    {/* <FormLabel className="req city">Выберите ближайший ТЦ</FormLabel>
                                                    <div className="row-city">
                                                        <Form.Group>
                                                            <Form.Control
                                                                as="select"
                                                                onChange={selectCenter}
                                                                value={idCenter}
                                                            >
                                                                {isIterableArray(tcList) &&
                                                                    tcList.map(tc => (
                                                                        <option key={tc.tcId} value={tc.tcId}>
                                                                            {tc.tcName}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </div>

                                    {texts?.text3?.text && <AlertCart data={texts.text3} />}
                                </div>
                            </div>

                            {/* ========== ШАГ 3: Оплата ========== */}
                            <div className="checkout-form__step">
                                <div className="checkout-form__step__number">
                                    <span>3</span>
                                </div>
                                <div className="checkout-form__step__wrap">
                                    <h5>Оплата</h5>
                                    <div className="checkout-payment">
                                        <Form.Group className="checkout-payment__item">
                                            <Form.Check
                                                type="radio"
                                                id="payment1"
                                                name="payment"
                                                value="1"
                                                onChange={changeInput}
                                                label='Наличный расчёт'
                                                checked={payment === '1'}
                                            />
                                        </Form.Group>
                                        <Form.Group className="checkout-payment__item">
                                            <Form.Check
                                                type="radio"
                                                id="payment2"
                                                name="payment"
                                                value="2"
                                                onChange={changeInput}
                                                label='Безналичный расчёт'
                                                checked={payment === '2'}
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className="checkout-comment">
                                        <Form.Group controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>Дополнительная информация к заказу</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows="3"
                                                onChange={changeInput}
                                                name="comment_user"
                                                value={commentUser}
                                                placeholder="Комментарий"
                                            />
                                        </Form.Group>
                                    </div>

                                    {texts?.text4?.text && <AlertCart data={texts.text4} />}
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* ========== Сайдбар ========== */}
                    <Col xs={12} lg={4}>
                        <div className="checkout-total">
                            <div className="checkout-total__wrap">
                                <h5>Состав заказа</h5>
                                <div className="cart-items">
                                    <div className="cart-items__wrap">
                                        {products.map((product, index) => (
                                            <CartItem
                                                key={index}
                                                product={product}
                                                index={index}
                                                isControl={props.isControl}
                                            />
                                        ))}
                                    </div>
                                </div>

                                <div className="checkout-total__info">
                                    <div className="info">
                                        <p>Товаров на сумму:</p>
                                        <span className="i-rub">
                                            {parseFloat((totalSumm * 1).toFixed(2)).toLocaleString('ru')}
                                        </span>
                                    </div>

                                    <div className="info">
                                        {delivery === '1' && (
                                            <>
                                                <p>Самовывоз</p>
                                                <span>
                                                    {tcList.find(tc => String(tc.tcId) === String(pickupTcId))?.tcName}
                                                </span>
                                            </>
                                        )}
                                        {delivery === '99' && (
                                            <>
                                                <p>Доставка</p>
                                                <span>Курьером</span>
                                            </>
                                        )}
                                    </div>

                                    <div className="info">
                                        <p>Оплата</p>
                                        {payment === '1' && <span>Наличный расчёт</span>}
                                        {payment === '2' && <span>Безналичный расчёт</span>}
                                    </div>
                                </div>

                                <div className="checkout-total__footer">
                                    <div className="info">
                                        <p>Итого к оплате:</p>
                                        <span className="i-rub">
                                            {totalSumm.toLocaleString('ru')}
                                        </span>
                                    </div>

                                    <Button
                                        variant="primary"
                                        disabled={isLoadingSubmit || !confirmed || totalSumm < texts?.min_price}
                                        onClick={submitOrder}
                                    >
                                        {
                                            isLoadingSubmit ? 'Создаем заказ...' : 'Подтвердить заказ'
                                        }

                                    </Button>

                                    <NavLink to='/cart'>
                                        <Button variant="link">Редактировать заказ</Button>
                                    </NavLink>

                                    {
                                        valid && (
                                            <CheckoutCompleteModal
                                                num={orderNumber}
                                                cName={`${firstName} ${lastName}`}
                                                cPhone={phone}
                                                cEmail={email}
                                                cAddress={`${city}, ${address}, д.${home}, кв.${flat}`}
                                                del={delivery}
                                                paym={payment}
                                                comment={commentUser}
                                                companyName={companyName}
                                                companyInn={companyInn}
                                                products={products}
                                                pickupTcName={
                                                    tcList.find((tc) => String(tc.tcId) === String(pickupTcId))?.tcName || ''
                                                }
                                                totalSumm={totalSumm}
                                            />
                                        )
                                    }

                                    {!checkPhone && <BlackListModal />}

                                    <div className="check-accept-order">
                                        <div className="checkbox-filter__item">
                                            <input className="custom-checkbox filter-check brand-check" type="checkbox" onChange={ppConfirm} id="m6" />
                                            <label htmlFor="m6">
                                                <div className='d-flex flex-wrap align-items-center'>
                                                    {
                                                        texts?.text5?.text ?
                                                            <div dangerouslySetInnerHTML={{ __html: texts?.text5?.text }} />
                                                            :
                                                            'Подтверждая заказ, я принимаю условия пользовательского соглашения'
                                                    }
                                                </div>
                                            </label>
                                        </div>
                                    </div>

                                    <div style={{ color: '#e04542' }}>
                                        {submitTry && !valid &&
                                            Object.keys(errors).map((err, i) => (
                                                <p key={i}>{errors[err]}</p>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </main>
    );
};

export default Checkout;